import {MemexColumnDataType} from '../../../../../api/columns/contracts/memex-column'
import type {DateColumnModel} from '../../../../../models/column-model/custom/date'
import {DataTypeMismatchFailureError} from '../errors'
import type {ClipboardContent} from '../types'

export const buildDateUpdateFromClipboardContent = (content: ClipboardContent | string, column: DateColumnModel) => {
  if (typeof content === 'string') return // Do not allow arbitrary pasting for this data type

  if (content.dataType === MemexColumnDataType.Date) {
    const dateValue = content.value

    return {
      dataType: MemexColumnDataType.Date,
      memexProjectColumnId: column.id,
      value: dateValue ? {value: dateValue.value} : undefined,
    }
  }

  if (content?.value) throw new DataTypeMismatchFailureError()

  return {
    dataType: MemexColumnDataType.Date,
    memexProjectColumnId: column.id,
    value: undefined,
  }
}
